import React from "react"
import Layout from "../components/layout"
import { motion } from "framer-motion"

import NavBar from "../components/NavBar"
import LabelImage from "../components/LabelImage"
import CTA from "../components/CTA"

import FooterSection from "../sections/footer-section"

import { theme } from "../theme/theme"

const AboutPage = () => {
  return (
    <Layout>
      <NavBar
        style={{
          position: "absolute",
          width: "100%",
          top: 0,
          backgroundColor: theme.colors.white0,
          zIndex: 1,
        }}
      />
      <motion.div
        id={"about-container"}
        style={{
          height: "auto",
          paddingTop: 150,
          paddingLeft: 10,
          width: "100vw",
          backgroundColor: theme.colors.secondary,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <motion.div
          id={"about-image"}
          style={{ width: "40%", paddingRight: 50, paddingTop: 100 }}
        >
          <LabelImage
            src={"./extra-2.png"}
            squareBackground={theme.colors.white0}
          />
        </motion.div>
        <motion.div
          id={"about-description"}
          style={{ width: "40%", paddingRight: 50, marginBottom: 150 }}
        >
          <motion.h1
            style={{
              lineHeight: 1.2,
              letterSpacing: 1,
              color: theme.colors.white0,
            }}
          >
            ABOUT.
          </motion.h1>
          <motion.p style={{ color: theme.colors.white0 }}>
            Driven by our passion for creativity and people, Brand New Labels is
            all about raising awareness for the new and upcoming fashion labels.
            We're committed to serving only the best brands, the ones that care
            the most about the products they make and the story they tell.
          </motion.p>
          <motion.p style={{ color: theme.colors.white0 }}>
            Founded in 2019 by Mirthe Bouw, Brand New Labels sets out to take a
            new narrative on the fashion scene in the Netherlands.
          </motion.p>
          <motion.p style={{ color: theme.colors.white0 }}>
            Whether you’re looking for the best basics or that one signature
            piece, we're bringing the most promising up and coming labels to you
            directly. All while supporting new and local brands who care the
            most about people and planet. Those who are eager to share their
            passion and creativity.
          </motion.p>
          <motion.p style={{ color: theme.colors.white0 }}>
            We're always seeking for new labels to collaborate with, so don't
            hesitate to reach out if you think we’re cool enough to work with.
            If you got what it takes to make a stand and show off some style,
            bring-it-onnnn.
          </motion.p>
          <CTA
            color={theme.colors.white0}
            text={"COLLAB WITH US"}
            href={"/contact"}
          />
        </motion.div>
      </motion.div>

      <FooterSection />
    </Layout>
  )
}

export default AboutPage
